import {
  Row,
  Col,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import React, { useState, useEffect } from "react"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import Loading from 'lib/loading'

const ListaControles = ({ form }) => {

  const [controles, setControles] = useState([])
  const [loading, setLoading]     = useState(true)

  const lista = () => {
    try{
      const retorno = rest.get(rotas.perfil_controleItem)
      retorno.then(ret => {
        if ((ret.success) && (ret.lista != '')){
          setControles(ret.lista)
        }
      })
      setLoading(false)
      return (true)
    }catch(err){
      return (false)
    }
  }

  useEffect(() => {
    lista()
  },[])

  const listaCheckbox = controles.map((controle) => {
    if (controle.itens && controle.itens != '') {
      return (
        <div className="card-2 mt-4 w-100" key={"divops"+controle.controle_id}>
          <Col md='12'>
            <span className="tag-card"><b>{controle.nome}</b></span>
            <Row>
            {
              controle.itens.map((item) =>
              <Col className="p-0" md="2" key = {"Col" + item.controle_item_id}>
                <FormGroup className="m-2"  key = {"FormGroup" + item.controle_item_id} check>
                  <Label style={{paddingLeft: '30px'}} check>
                    <Input
                      disabled
                      type            = "checkbox"
                      id              = {"controleItem" + item.controle_item_id}
                      key             = {"controleItem" + item.controle_item_id}
                      name            = "fidelidade"
                      label           = {item.nome}
                      defaultChecked  = {form[item.component] == 'S' ? true : false}
                    />
                    <span className="form-check-sign" />{item.nome}
                  </Label>
                </FormGroup>
              </Col>
              )
            }
            </Row>
          </Col>
        </div>
      )
    } else {
      return (
        <div className="card-2 mt-4 w-100" key={"divosp"+controle.controle_id}>
          <Col md='12'>
            <span className="tag-card"><b>{controle.nome}</b></span>
            <Row>
            <Col className="p-0" md="2">
              <FormGroup className="m-2" key = {"FormGroup" + controle.controle_id} check>
                <Label style={{paddingLeft: '30px'}} check>
                  <Input
                    disabled
                    type            = "checkbox"
                    id              = {"controleItem" + controle.controle_id}
                    key             = {"controleItem" + controle.controle_id}
                    name            = "fidelidade"
                    label           = {controle.nome}
                    defaultChecked  = {form[controle.component] == 'S' ? true : false}
                  />
                  <span className="form-check-sign" />{controle.nome}
                </Label>
              </FormGroup>
            </Col>
            </Row>
          </Col>
        </div>
      )
    }
  })

  if (loading) {
    return (
      <Row>
        <Loading tipo='componente' />
      </Row>
    )
  } else {
    return (
      <Col md='12' key="ops">
        {listaCheckbox}
      </Col>
    )
  }
}

export default ListaControles
